<template>
    <div>
        <div class="profile">
            <div class="profile__left">
                <div class="profile__title">Password</div>
                <div class="profile__caption">Change Password</div>
            </div>
            <div class="profile__right">
                <form>
                    <div class="form__item">
                        <label class="form__label" for>Current Password</label>
                        <input class="form__input" type="password" v-model="currentPassword.value" />
                        <span class="attention" v-if="currentPassword.empty">Field can't be empty</span>
                    </div>
                    <div class="form__item">
                        <label class="form__label" for>New Password</label>
                        <input autocomplete="new-password" class="form__input" type="password" v-model="newPassword.value" />
                        <span class="attention" v-if="newPassword.empty">Field can't be empty</span>
                    </div>
                    <div class="form__item">
                        <label class="form__label" for>Confirm Password</label>
                        <input autocomplete="new-password" class="form__input" type="password" v-model="confirmNewPassword.value" />
                        <span class="attention" v-if="confirmNewPassword.empty">Field can't be empty</span>
                    </div>
                </form>
            </div>
        </div>
        <div class="action">
            <button :disabled="disabled" @click="changePassword" class="btn btn--primary">Save Changes</button>
        </div>

        <div aria-labelledby="confirmOTPLabel" class="modal fade" id="confirmOTP" role="dialog" tabindex="-1">
            <!-- Modal Dialog -->
            <div class="modal__dialog modal__dialog--sm" role="document">
                <!-- Modal content -->
                <div class="modal__content">
                    <div class="modal__header">
                        <div class="modal__title text-center">Validate OTP</div>
                        <!-- Modal close button -->
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <svg height="13" viewBox="0 0 13 13" width="13" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z" fill="#C0C6D8" fill-rule="nonzero" />
                            </svg>
                        </button>
                    </div>
                    <!-- Modal Body -->
                    <div class="modal__body modal__body--pad">
                        <form @submit.prevent="updatePassword" class="form">
                            <div class="form__pad">
                                <div class="form__item">
                                    <label class="form__label form__label--2" for>Enter the OTP sent to your email address</label>
                                    <input @keydown="preventKeys" autofocus class="form__input" type="text" v-model="otp.value" />
                                    <span class="attention" v-if="otp.empty">Field can't be empty</span>
                                </div>
                            </div>

                            <div class>
                                <button :disabled="disabled" class="btn btn--primary btn--block" type="submit">Continue</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: "Settings - Password"
    },
    data() {
        return {
            currentPassword: {
                value: "",
                empty: false
            },
            newPassword: {
                value: "",
                empty: false
            },
            confirmNewPassword: {
                value: "",
                empty: false
            },
            otp: {
                value: "",
                empty: false
            },
            disabled: false
        };
    },

    methods: {
        updatePassword() {
            this.otp.empty = false;
            if (this.otp.value !== "") {
                this.disabled = true;
                let requestObject = {
                    password: this.currentPassword.value,
                    new_password: this.newPassword.value,
                    otp: this.otp.value
                };

                this.$http
                    .post("dashboard/merchants/change_password", requestObject)
                    .then(response => {
                        this.disabled = false;
                        // Notify success
                        this.$notify({
                            group: "notifications-default",
                            type: "success text-white",
                            title: "Success",
                            text: response.body.message
                        });

                        $("#confirmOTP").modal("hide");
                        // redirect to login page and clear localstorage
                        window.localStorage.clear();
                        this.$router.push({ path: "/login" });
                    })
                    .catch(error => {
                        this.disabled = false;
                        this.$notify({
                            group: "notifications-default",
                            type: "error text-white",
                            title: "Error",
                            text: error.body.message
                        });
                    });
            } else {
                this.otp.empty = true;
            }
        },
        changePassword() {
            this.resetEmptyStates();
            // check that items are not empty
            if (this.currentPassword.value !== "" && this.newPassword.value !== "" && this.confirmNewPassword.value !== "") {
                // check that new password and confirm passsword are the same
                if (this.newPassword.value.trim() == this.confirmNewPassword.value.trim()) {
                    this.disabled = true;
                    // Trigger OTP send
                    this.$http
                        .post(`dashboard/merchants/otp/generate`, {
                            password: this.currentPassword.value
                        })
                        .then(response => {
                            // Open the otp Modal

                            $("#confirmOTP").modal("show");
                            this.disabled = false;
                        })
                        .catch(error => {
                              this.$notify({
                                group: "notifications-default",
                                type: "error text-white",
                                title: "Error",
                                text: error.body.message
                            });
                            // Recall the otp generate
                            this.disabled = false;
                        });
                } else {
                    this.disabled = false;
                    this.$notify({
                        group: "notifications-default",
                        type: "error text-white",
                        title: "Error",
                        text: "New Password and Confirm password fields has to be the same."
                    });
                }
            } else {
                if (this.currentPassword.value == "") {
                    this.currentPassword.empty = true;
                }
                if (this.newPassword.value == "") {
                    this.newPassword.empty = true;
                }
                if (this.confirmNewPassword.value == "") {
                    this.confirmNewPassword.empty = true;
                }
            }
        },
        // Reset the values
        resetList() {
            this.currentPassword.value = "";
            this.newPassword.value = "";
            this.confirmNewPassword.value = "";
        },

        resetEmptyStates() {
            this.currentPassword.empty = false;
            this.newPassword.empty = false;
            this.confirmNewPassword.empty = false;
        }
    }
};
</script>